<template>
  <div class="d-flex flex-column align-items-start">
    <div class="d-inline">
      <b-icon icon="dot" />
      <span class="title">{{ title }}</span>
    </div>
    <span class="description ml-3">{{ description }}</span>
    <b-img v-if="showImage" class="example ml-3" :src="imageLink" />
  </div>
</template>

<script>
export default {
  name: 'NoteItem',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: ""
    },
    image: {
      type: String,
      default: "",
    },
  },
  data() {
    return{
      showImage: true,
    }
  },
  mounted() {
    this.showImage = this.image !== "";
  },
  computed: {
    imageLink(){
      if (this.image !== "") {
        return require(`./../assets/release_notes/${this.image}`);
      }

      return "";
    }
  }
}
</script>

<style scoped>
.title{
  font-size: 1.2em;
  font-weight: 300;
}
</style>
